exports.copyText = (password) => {
  navigator.clipboard.writeText(password);
};
